// import useForm from '../hooks/useForm.js';
import useUth from "../hooks/useUth.js";
import React, { useState, useEffect } from "react";
import {
  validateProblem,
  validateFile,
  validateAsunto,
  clearImages,
} from "../hooks/uthValidation.js";

import styled from "styled-components";
import Modal from "../components/Modal.js";
import Spinner from "../components/Spinner";
import ErrorMessage from "../components/Error.js";

// imagen
import logo1 from "../images/financieras1.png";

// Styles
import "../css/stylesUTH.css";
import "../user_financieras/user_financieras.css";

const FormFinancieras = (props) => {
  const [estadoModal, cambiarEstadoModal] = useState(false), //Contiene el estado para activar el Modal
    [area, setArea] = useState(""), //Almacena el valor seleccionado en el dropdown Que problema tienes
    [state, setState] = useState(""), //Almacena el valor seleccionado en el dropdown Área Afectada
    [Sucursal, setSucursal] = useState(""), //Almacena el valor seleccionado en el dropdown Campus
    [Empresa, setEmpresa] = useState(props.company), //Almacena el valor seleccionado en el dropdown Company
    [isLoading, setLoading] = useState(false), //Contiene el estado para activar el spinner
    [isError, setError] = useState(false); //Contiene el estado para mostrar el mensaje de error

    useEffect(() => {
      // Load options for "campus" dropdown based on the selected "company"
      if (Empresa) {
        // You may need to adjust this logic based on your data structure
        // const sucursalesDeEmpresa = Empresas.find(
        //   (empresa) => empresa.id === Empresa
        // )?.Sucursales || [];
        setSucursal(""); // Reset "campus" dropdown
      }
    }, [Empresa]);

  //Funcion para obtener el valor de problemas y resetear Área Afectada
  const handleProblemaChange = (event) => {
    ValidFile();
    setArea(event.target.value);
    setState("");
  };

  //Obtener el valor de Área Afectada
  const handleStateChange = (event) => {
    setState(event.target.value);    
  };

  //JSON con lista de opciones para el campo con que tienes problemas
  const areas = [
    { id: "Aplicaciones", name: "Aplicaciones" },
    { id: "Otros", name: "Otros" },
  ];

  //JSON con lista de opciones para el campo Área Afectada de acuerdo al json anterior
  const estados = [
    { id: "Software", name: "FinPro", areaId: "Aplicaciones" },
    { id: "Siscae", name: "Siscae", areaId: "Aplicaciones" },
    { id: "Otros", name: "Otros", areaId: "Aplicaciones" },
    { id: "Accesos/Credenciales", name: "Accesos/Credenciales", areaId: "Otros" },
    { id: "Correo Electronico", name: "Correo Electrónico", areaId: "Otros" },
    { id: "Electricidad", name: "Electricidad", areaId: "Otros" },
    { id: "Hardware", name: "Hardware", areaId: "Otros" },
    { id: "Internet", name: "Internet", areaId: "Otros" },
    { id: "Otros", name: "Otros", areaId: "Otros" },
  ];

  //JSON con lista de opciones para el campo Company de acuerdo al json anterior
  const Empresas = [
    { id: "COGASA", name: "COGASA", Sucursales: ["San Pedro Sula"] },
    {
      id: "CrediMovil",
      name: "CrediMovil",
      Sucursales: ["San Pedro Sula", "Tegucigalpa"],
    },
    {
      id: "CrediRapid",
      name: "CrediRapid",
      Sucursales: ["San Pedro Sula", "Tegucigalpa"],
    },
    {
      id: "PrestaAuto",
      name: "PrestaAuto",
      Sucursales: ["La Ceiba", "San Pedro Sula", "Tegucigalpa"],
    },
    {
      id: "PrestaYa",
      name: "PrestaYa",
      Sucursales: ["La Entrada Copán", "San Pedro Sula", "Tegucigalpa"],
    },
    { id: "Mersa", name: "Mersa", Sucursales: ["San Pedro Sula"] },
    { id: "Compresa", name: "Compresa", Sucursales: ["San Pedro Sula"] },
    { id: "CrediBodega", name: "CrediBodega", Sucursales: ["San Pedro Sula"] },
    { id: "Inversa", name: "Inversa", Sucursales: ["San Pedro Sula"] },
  ];

  // Obtener las sucursales de la empresa seleccionada
  // const sucursalesDeEmpresa = Empresas.find((empresa) => empresa.id === props.company)?.Sucursales || [];
  const sucursalesDeEmpresa = (props.company ? 
    Empresas.find((empresa) => empresa.id === props.company)?.Sucursales : 
    Empresas.find((empresa) => empresa.id === Empresa)?.Sucursales) || [];
  

  //Filtro entre Área Afectada y Problemas.
  const filteredProblem = estados.filter((state) => state.areaId === area);

  //Validaciones del File
  function ValidFile() {
    var valFile = document.getElementById("file"); //Obtiene la lista de imagenes en el drag and drop
    var valArea = document.getElementById("area").value; //Obtiene el valor del problema descrito por el usuario

    // clearImages();
    if (
      valArea === "Aplicaciones" &&
      document.getElementById("file").value === ""
    ) {
      valFile.setAttribute("required", true);
      document.getElementById("area").style.backgroundColor = "white";
      document.getElementById("submitButton").disabled = true;
      document.getElementById("submitButton").className =
        "fuente btn btn-secondary mb-2";
    }

    if (
      valArea === "Aplicaciones" &&
      document.getElementById("file").value !== ""
    ) {
      valFile.setAttribute("required", true);
      document.getElementById("area").style.backgroundColor = "white";
      document.getElementById("submitButton").disabled = false;
      document.getElementById("submitButton").className =
        "fuente btn btn-primary mb-2";
    }

    if (
      valArea === "Otros" &&
      document.getElementById("asunto").className ===
        "fuente form-control is-invalid" &&
      document.getElementById("problem").className === "form-control is-invalid"
    ) {
      valFile.removeAttribute("required");
      document.getElementById("area").style.backgroundColor = "white";
      document.getElementById("submitButton").disabled = true;
      document.getElementById("submitButton").className =
        "fuente btn btn-secondary mb-2";
    }

    if (
      valArea === "Otros" &&
      document.getElementById("asunto").className ===
        "fuente form-control is-valid" &&
      document.getElementById("problem").className === "form-control is-valid"
    ) {
      valFile.removeAttribute("required");
      document.getElementById("submitButton").disabled = false;
      valFile.removeAttribute("required");
      document.getElementById("submitButton").className =
        "fuente btn btn-primary mb-2";
    }
  }

  //Función para contar los caracteres del textarea y mostrarlo
  function contarcaracteres() {
    var total = 1000;

    setTimeout(function () {
      var valor = document.getElementById("problem");
      var respuesta = document.getElementById("res");
      var cantidad = valor.value.length;
      document.getElementById("res").innerHTML = `${total - cantidad}/${total}`;
      // document.getElementById('res').innerHTML = `${cantidad}/${total - cantidad}`;
      if (cantidad > total) {
        respuesta.style.color = "red";
      } else {
        respuesta.style.color = "black";
      }
    }, 10);
  }

  //handleSubmitForm: función que se pasa al onSubmit del formulario para validarlo
  function handleSubmitForm(event) {
    event.preventDefault();
    setLoading(!isLoading);

    let files = document.getElementById("file").files;
    let x = [];
    let fil = [];
    for (let i = 0; i < files.length; i++) {
      (function (file) {
        var reader = new FileReader();
        reader.onload = (file) => {
          x[i] = reader.result;
        };
        reader.readAsDataURL(file);
      })((fil[i] = files[i]));
    }

    let imageRoute = [];
    var file = document.getElementById("file");
    for (let x = 0; x < file.files.length; x++) {
      imageRoute[x] = URL.createObjectURL(file.files[x]);
    }

    var formdata = new FormData();
    formdata.append("name", event.target.name.value);
    formdata.append("email", event.target.email.value);
    formdata.append("area", event.target.area.value);
    formdata.append("state", event.target.state.value);
    formdata.append("asunto", event.target.asunto.value);
    formdata.append("problema", event.target.problem.value);
    formdata.append("city", event.target.campus.value);
    formdata.append("company", event.target.company.value);
    for (var i = 0; i < file.files.length; i++) {
      formdata.append("image", file.files[i]);
    }

    // console.log(formdata);

    var requestOptions = {
      method: "POST",
      Headers: { "Access-Control-Allow-Origin": "*" },
      body: formdata,
      redirect: "follow",
    };

    fetch("https://soporteinversa.uth.hn/api/financieras/", requestOptions)
      .then((response) => {
        if (!response.ok) {
          setLoading(isLoading);
          setError(!isError);
          close_error();
          newTicket();
          clearImages();
        } else {
          setLoading(!isLoading);
          cambiarEstadoModal(!estadoModal);
        }
        return response.text();
      })
      // .then((result) => console.log(result))
      .catch((error) => {
        setLoading(!isLoading);
        console.log("error", error);
      });
  }

  //Funcion para cambiar el estado de los componentes
  function close() {
    setLoading(!isLoading);
    cambiarEstadoModal(!estadoModal);
    setArea("");
    setState("");
    setEmpresa("");
    setSucursal("");
  }

  //Funcion para cambiar el estado de los componentes en caso de error
  function close_error() {
    // newTicket();
    setArea("");
    setState("");
    setEmpresa("");
    setSucursal("");
  }

  const { values, setFieldValue, errors, resetForm, newTicket } =
    useUth({
      /* Valores iniciales del formulario */
      initialValues: {
        name: props.name,
        email: props.email,
        company: props.company,
        problema: "",
        file: [],
      },
      validate: (property, value) => {
        /* Validación en cada campo individualmente */
        const errorObj = {};

        switch (property) {
          case "asunto":
          const testAsunto = validateAsunto({
            asunto: property,
            value,
            required: "Asunto es requerido.",
            max: 100,
            min: 5,
            shortValue:
              "El límite de caracteres ha sido excedido (Máximo 100 caracteres).",
            maxValue:
              "No hay información suficiente para crear el Ticket (Mínimo 5 caracteres).",
            validateAsunto: "Error, Favor ingresar solo caracteres alfabeticos.",
          });
          Object.assign(errorObj, testAsunto);
          break;
          case "problema":
            const testProblem = validateProblem({
              problema: property,
              value,
              required: "Descripción es requerida.",
              max: 1000,
              min: 20,
              shortValue:
                "El limite de caracteres ha sido excedido (Máximo 1000 caracteres).",
              maxValue:
                "No hay información suficiente para crear el Ticket (Mínimo 20 caracteres).",
            });
            Object.assign(errorObj, testProblem);
            break;
          case "file":
            /* VERIFICA EL HOOK useValidation y su función validateEmail */
            const testFile = validateFile({
              value,
              required: "Imágenes son requeridas.",
              max: 5,
              validFile:
                "La imagen esta en un formato no permitido (Permitidos .jpg, .png, .jpeg, .pdf, .docx, .xlsx).",
              shortValue:
                "El máximo de imágenes adjuntadas ha sido excedido (Máximo 5).",
            });
            Object.assign(errorObj, testFile);
            break;
            default:
              break;
        }

        return errorObj;
      },
      onSubmit: ({ values, resetForm }) => {
        // cambiarEstadoModal(!estadoModal);
      },
    });

  return (
    //Contenedor para Formulario de Financieras
    <div className="container">
      {/* Logo de las empresas */}
      {/* <div className="imagenFinanciera"> */}
        <img src={logo1} alt="" className="img-financiera" />
      {/* </div> */}
      <div className="form-financieras col-auto row justify-content-center">
        {/* Formulario para recolección de información sobre el fallo  */}
        <form className="form-control pt-0" onSubmit={handleSubmitForm}>
          <div className="col-auto text-center">
            {/* Botón para cerrar el form y volver al principal */}
            <button
              type="button"
              id="close"
              className="btn-close top-10"
              onClick={resetForm}
            ></button>
          </div>
          <p className="fw-normal fs-4 text-center">
            Verificación de Usuario Financieras
          </p>

          {/* Mostrar nombre y correo estáticos desde las props del form anterior */}
          <div className="row g-12">
            <div className="col-sm-6 mb-3">
              <input
                type="text"
                value={props.name}
                id="name"
                name="name"
                className="fuente form-control"
                disabled
              />
            </div>
            <div className="col-sm-6 mb-3">
              <input
                type="email"
                value={props.email}
                id="email"
                name="email"
                className="fuente form-control"
                disabled
              />
            </div>
          </div>
          {/* dropdown sucursales */}
          {/* Obtener el departamento y empresa en la que labora el usuario */}
          <div className="col-sm">
            <p className="fs-6 mb-0">Describe tu solicitud</p>
          </div>
          <div className="row gx-12">
            {props.company ? (
              <div className="col-sm-6 mb-2">
                {/* Replace the "select" with an "input" */}
                <input
                  type="text"
                  className="fuente form-control"
                  name="company"
                  id="company"
                  value={props.company}
                  disabled  // Make the input non-editable
                />
              </div>
            ) : (
              <div className="col-sm-6 mb-2">
                <select
                  className="fuente form-select"
                  name="company"
                  id="company"
                  value={Empresa}
                  onChange={(e) => setEmpresa(e.target.value)}
                  required
                >
                  <option disabled hidden value="">
                    Empresa
                  </option>
                  {Empresas.map((empresa) => (
                    <option key={empresa.id} value={empresa.id}>
                      {empresa.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="col-sm-6 mb-2">
              <select
                autoFocus
                className="fuente form-select"
                name="campus"
                id="campus"
                value={Sucursal}
                onChange={(e) => setSucursal(e.target.value)}
                disabled={!props.company && !Empresa}
              >
                <option disabled hidden value="">
                  Sucursal
                </option>
                {/* Dynamically generate options based on the selected "company" */}
                {sucursalesDeEmpresa.map((sucursal) => (
                  <option key={sucursal} value={sucursal}>
                    {sucursal}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/* dropdown cual es tu problema*/}
          {/* Obtener el tipo de percance y el área afectada */}
          <div className="row gx-12">
            <div className="col-sm-6 mb-2">
              <select
                className="fuente form-select"
                name="area"
                id="area"
                required
                value={area}
                onChange={handleProblemaChange}
              >
                <option disabled hidden value="">
                  Área
                </option>
                {areas.map((area) => (
                  <option key={area.id} value={area.id}>
                    {area.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-sm-6 mb-2">
              <select
                className="fuente form-select"
                name="state"
                id="state"
                value={state}
                onChange={handleStateChange}
                disabled={!area}
              >
                <option disabled hidden value="">
                  Sub-área
                </option>
                {filteredProblem.map((estado) => (
                  <option key={estado.id} value={estado.id}>
                    {estado.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/* fin de los dropdowm */}

          <div className="mb-3">
            {/* Permite ingresar la descripción del problema técnico */}
            <input
              type="text"
              className="fuente form-control"
              name="asunto"
              id="asunto"
              required
              placeholder="Asunto..."
              value={values.asunto}
              onChange={(e) => setFieldValue("asunto", e.target.value)}
            />
            {errors.asunto && (
              <span className="error-message">{errors.asunto}</span>
            )}
          </div>

          <div className="mb-3">
            {/*descripcion del problema*/}
            {/* Permite ingresar la descripción del problema técnico */}
            <textarea
              className="fuente form-control"
              rows={3}
              name="problem"
              id="problem"
              placeholder="Describa su solicitud..."
              value={values.problema}
              onChange={(e) => setFieldValue("problema", e.target.value)}
              onPaste={contarcaracteres()}
              onKeyUp={contarcaracteres()}
            />
            <label className="fuente text mb-2" id="res">
              0/0
            </label>
            {/* <div className="text-danger">{errors.problema}</div> */}
            {errors.problema && (
              <span className="fuente error-message">{errors.problema}</span>
            )}
          </div>         

          {/* para insertar los files dentro del form*/}
          {/*Admite documentos pdf e imagenes para evidencia del problema */}
          <div className="col-sm">
            <p className="fs-6 mb-0">Adjunte Archivos</p>
          </div>
          <div>
            <input
              type="file"
              label="Adjunte Imagenes"
              id="file"
              name="file"
              className="fuente input_divDropFile"
              accept="image/*,.pdf,.xlsx,.docx"
              multiple
              onChange={(e) => setFieldValue("file", e.target.files)}
            />
            {errors.file && (
              <span className="fuente error-message">{errors.file}</span>
            )}
            {/* <div className="text-danger">{errors.file}</div> */}
          </div>

          {/* IMAGE PREVIEW CONTAINER */}
          <div className="containerImg" id="containerFile"></div>

          <div className="fuente d-grid gap-2 col-4 mx-auto">
            <button
              className="btn btn-secondary shadow text-center mt-3 mb-1"
              type="submit"
              id="submitButton"
              disabled
            >
              Crear Ticket
            </button>
          </div>

          {/* Spinner de carga cuando se ejecuta el fetch */}
          <Spinner estado={isLoading} />

          {/* Mensaje de error se visualiza cuando el fetch no funciona correctamente */}
          <ErrorMessage estado={isError} />

          {/* Ventana modal es visible cuando finaliza con éxito la ejecución del fetch */}
          <Modal estado={estadoModal} cambiarEstado={cambiarEstadoModal} titulo={'Éxito'}>
            <Contenido>
              <p className="fs-6">
                Tu ticket ha sido creado satisfactoriamente. Un correo de
                confirmación ha sido enviado a <strong>{props.email}</strong>.
              </p>
              <ContenidoB>
                <BotonT
                  onClick={() => {
                    close();
                    newTicket();
                    clearImages();
                  }}
                >
                  Crea otro ticket
                </BotonT>
                &nbsp;&nbsp;
                <Boton onClick={resetForm}>Cerrar</Boton>
              </ContenidoB>
            </Contenido>
          </Modal>
        </form>
      </div>
    </div>
  );
};

export default FormFinancieras;

  /* Estilos para el form del Modal */
const Contenido = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h1 {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
  }
`;

const ContenidoB = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Boton = styled.button`
  display: block;
  padding: 10px 35px;
  border-radius: 10px;
  color: #fff;
  border: none;
  background: #1766dc;
  cursor: pointer;
  font-family: "Roboto";
  font-weight: 10;
  font-size: 14px;
  transition: 0.3s ease all;
  &:hover {
    background: #639cf2;
  }
`;
const BotonT = styled.button`
  display: block;
  padding: 10px 5px;
  border-radius: 10px;
  color: #fff;
  border: none;
  background: #babec2;
  cursor: pointer;
  font-family: "Roboto";
  font-size: 14px;
  transition: 0.3s ease all;
  &:hover {
    background: #8d99a6;
  }
`;
